import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';
import type { Contact } from '../types/contact';

export function useContacts() {
  const [contacts, setContacts] = useState<Contact[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetchContacts();
  }, []);

  async function fetchContacts() {
    try {
      const { data, error } = await supabase
        .from('nrm_contacts')
        .select(`
          *,
          company:nrm_companies(
            id,
            name
          )
        `)
        .order('last_name', { ascending: true });

      if (error) throw error;
      setContacts(data || []);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An error occurred');
      console.error('Error fetching contacts:', err);
    } finally {
      setLoading(false);
    }
  }

  return { contacts, loading, error, refetch: fetchContacts };
}